<div class="container">

    <section class='header'>
        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div class='header-title'>
                <mat-icon style='font-size:.9em;'>layers_clear</mat-icon>
                <div class='title'>
                    Reembolso
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>

        </mat-toolbar>
    </section>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-form-field class="date-width" appearance="fill">
          <label>Data</label>
            <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="entityForm.controls.date.hasError('required')">
                A data limite é obrigatoria
            </mat-error>
        </mat-form-field>


        <mat-form-field class="percent-width" appearance="fill">
          <label>%</label>
            <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.percent"
                autocomplete="off">
            <mat-error *ngIf="entityForm.controls.percent.hasError('required')">
                A porcentagem é obrigatória
            </mat-error>
        </mat-form-field>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
    </div>

</div>